import React from "react";
import { useTranslation } from "react-i18next";
import Button from "src/components/Button";
import Layout from "src/components/layout/Layout";
import useAuth from "src/hooks/selectors/useAuth";

interface MiddlewareLayoutProps {
	children?: any;
	title: string;
	heading: string;
	loading?: boolean;
	tabs?: any;
}

const MiddlewareLayout = ({
	children,
	title,
	heading,
	loading,
	tabs,
}: MiddlewareLayoutProps) => {
	const { t } = useTranslation("middlewares", {
		keyPrefix: "layout",
	});
	const auth = useAuth();
	return (
		<Layout {...{ title, loading }}>
			{tabs}
			<div className="flex flex-1 flex-col gap-4 justify-center items-center text-center">
				<h2>{heading}</h2>
				<p className="text-center max-w-md">{children}</p>
				<Button
					className="mt-4"
					to={
						auth.has_subscription
							? "/profile/billing/change"
							: "/subscription"
					}
				>
					{auth.has_subscription
						? t("button.with-subscription")
						: t("button.without-subscription")}
				</Button>
			</div>
		</Layout>
	);
};

export default MiddlewareLayout;
